import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldError } from 'app/shared/forms/form-validation.util';

@Component({
  selector: 'form-error-summary',
  templateUrl: './form-error-summary.component.html',
  styleUrls: ['./form-error-summary.component.scss']
})
export class FormErrorSummaryComponent {

  @Input() errors: FieldError[] = []
  @Output() jumpTo: EventEmitter<string> = new EventEmitter<string>()

  onClick(key: string): void {
    this.jumpTo.emit(key)
  }

}
